import { render, staticRenderFns } from "./UpdateAttendanceDialog.vue?vue&type=template&id=cdfc8ff6&"
import script from "./UpdateAttendanceDialog.vue?vue&type=script&setup=true&lang=js&"
export * from "./UpdateAttendanceDialog.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports